// The requests App.vue fires as the SPA starts, and a way to wait for them.
//
// One caller needs to: AutoLogin, which must not exchange its one-time token
// while any of them is in flight. The exchange rotates the session key, and
// every API response re-sends a session cookie
// (api/middleware.py:expiring_session_middleware), so a boot response that
// lands after the exchange's replaces the new session cookie with a dead one
// and the user is signed straight back out. See pages/AutoLogin.vue.

// How long the exchange will wait. Nothing here times a request out, so without
// a bound one hung boot request would hold sign-in forever. Past it the
// exchange goes ahead beside whatever is still in flight, which is the old
// behavior. Long rather than short on purpose: slow, uneven responses are the
// conditions the race needs. The Expo app gives the whole handover 20 seconds
// (HANDOVER_TIMEOUT_MS in its src/auth/handover.ts), so this must stay well
// under that.
export const BOOT_WAIT_CAP_MS = 10 * 1000

let markSettled
const settled = new Promise((resolve) => {
    markSettled = resolve
})

// App.vue hands over the promises of what it dispatched at mount. A request
// that fails has still finished, which is all that matters here.
export function trackBootRequests(promises) {
    Promise.allSettled(promises).then(markSettled)
}

// Resolves once every boot request has answered or failed, or at the cap. It
// waits for App.vue to have started them, so it does not matter which of the
// two components mounts first.
//
// Resolves to 'settled' or 'capped', so that a sign-in which then fails can say
// which it was: past the cap the race this exists to prevent is open again.
export function bootRequestsSettled(capMs = BOOT_WAIT_CAP_MS) {
    return new Promise((resolve) => {
        const timer = setTimeout(() => resolve('capped'), capMs)
        settled.then(() => {
            clearTimeout(timer)
            resolve('settled')
        })
    })
}
